import { create } from 'zustand'

const useRoiTableStore = create((set) => ({
  visibleDates: new Set(),
  addVisibleDate: (date) =>
    set((state) => ({ visibleDates: new Set(state.visibleDates).add(date) })),
  removeVisibleDate: (date) =>
    set((state) => {
      const newVisibleDates = new Set(state.visibleDates)
      newVisibleDates.delete(date)
      return { visibleDates: newVisibleDates }
    }),
  getLatestVisibleDate: () => {
    const { visibleDates } = useRoiTableStore.getState()
    if (visibleDates.size === 0) {
      return null
    }
    return [...visibleDates].reduce((latest, current) =>
      current > latest ? current : latest,
    )
  },
}))

export default useRoiTableStore
